import { api } from '@/lib/api'
import type { Agenda } from './agendas'

export type CalendarEvent = {
  id: string
  name: string
  event_date: string
  event_time: string | null
  status: string
  agenda: string | null
}

export type Holiday = {
  date: string
  name: string
  type: string
  state: string | null
  city: string | null
}

export type CalendarParams = {
  start: string
  end: string
  agendaId?: string
  status?: string
  search?: string
}

export type CalendarReminder = {
  id: number
  event_id: string
  agenda_id: string
  reminder_date: string
  note: string | null
}

export type CalendarResponse = {
  events: CalendarEvent[]
  holidays: Holiday[]
  agendas: Agenda[]
  reminders: CalendarReminder[]
}

export const getCalendarService = (params: CalendarParams): Promise<CalendarResponse> =>
  api
    .get<CalendarResponse>('/api/calendar', {
      params: {
        Start: params.start,
        End: params.end,
        ...(params.agendaId && { AgendaId: params.agendaId }),
        ...(params.status && { Status: params.status }),
        ...(params.search && { Search: params.search }),
      },
    })
    .then((res) => res.data)
